import { CodeNameModel } from 'components/common/types';
import { DirectSalesCodeNameModel } from 'components/common/types/DirectSalesCampaign.types';
import {
  LocationLabel,
  LocationOption,
  LocationOption as LocationLabelKey,
  ReferenceLocation,
  ReferenceOption,
} from 'store/userOptions/reducer.types';

export const ORDERED_DSM_LOCATION_CATEGORY = [
  LocationLabel[LocationOption.TV_AREA],
  LocationLabel[LocationOption.COUNTY],
  LocationLabel[LocationOption.TOWN],
  LocationLabel[LocationOption.DISTRICT],
  LocationLabel[LocationOption.POSTCODE],
];

export const transformLocationToCategories = (locationOptions: ReferenceLocation): Record<string, CodeNameModel[]> => {
  return Object.entries(locationOptions).reduce<Record<string, CodeNameModel[]>>(
    (acc, [category, locations]: [string, ReferenceOption[]]) => {
      const isSingleCountryOption = category === (LocationLabelKey.COUNTRY as string) && locations?.length === 1;
      if (locations?.length > 0 && !isSingleCountryOption) {
        acc[LocationLabel[category as LocationLabelKey]] = locations.map(
          ({ code, name, mediaOwner, nameWithMediaOwner }) => ({
            code,
            name,
            ...(nameWithMediaOwner ? { nameWithMediaOwner } : {}),
            ...(mediaOwner ? { mediaOwner } : {}),
          }),
        );
      }
      return acc;
    },
    {},
  );
};

const transformLocationOptions = <T extends CodeNameModel>(
  options: T[],
): Pick<CodeNameModel, 'code' | 'name' | 'include' | 'category' | 'mediaOwner'>[] => {
  return options.reduce<Pick<CodeNameModel, 'code' | 'name' | 'include' | 'category' | 'mediaOwner'>[]>(
    (acc, { code, name, include, category, mediaOwner }) => {
      if (include !== undefined) {
        acc.push({ code, name, include, category, ...(mediaOwner ? { mediaOwner } : {}) });
      }
      return acc;
    },
    [],
  );
};

export const transformSelectedLocationsToCodeNameModels = (
  selectedLocations: DirectSalesCodeNameModel[],
): CodeNameModel[] => transformLocationOptions(selectedLocations);

export const transformCodeNameModelsToSelectedLocations = (
  selectedOptions: CodeNameModel[],
): DirectSalesCodeNameModel[] => transformLocationOptions(selectedOptions);
